import { render } from "./hostTopicInfo.vue?vue&type=template&id=4dc4d7a4&scoped=true"
import script from "./hostTopicInfo.vue?vue&type=script&lang=js"
export * from "./hostTopicInfo.vue?vue&type=script&lang=js"

import "./hostTopicInfo.vue?vue&type=style&index=0&id=4dc4d7a4&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc4d7a4"]])

export default __exports__